import ApiService from '../../services/api.service';
import EventModel from '../event/event-model';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerModel from '../owner/owner-model';
import UserModel from '../user/user-model';

export default class SectionModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    parent: any;
    parentCaption: string;
    title: string;
    content: string;
    seq: number;
    option: any;
    viewstyle: string;
    timelimit: number;
    questiontolerance: number;
    tag: string;
    image: any;
    imageId: number;
    imageUrl: string;
    sectionLength: number; //section section length
    questionLength: number;
    event: any;
    progress: number;
    progressTotal: number;

    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        let parent= datarow.parent?.data? new SectionModel(datarow.parent?.data) : datarow.parent;
        this.parent= parent?.id;
        this.parentCaption = parent?.name;
        this.title = datarow.title;
        this.content = datarow.content;
        this.seq = datarow.seq;
        this.option = datarow.option;
        this.viewstyle = datarow.viewstyle;
        this.timelimit = datarow.timelimit;
        this.questiontolerance = datarow.questiontolerance;
        this.tag = datarow.tag;
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';
        this.sectionLength = datarow.section?.data?.length || 0;
        this.questionLength = datarow.quizquestion?.data?.length || 0;
        this.event = datarow.event?.data?.map((d: any) => new EventModel(d))?.[0];
        let progressQuestion = this.event?.enddate? this.questionLength : this.event?.eventquizAnswered;
        let progressSection = this.event?.enddate? this.sectionLength : this.event?.eventEnded;
        this.progress = this.questionLength > 0? progressQuestion : this.sectionLength > 0? progressSection : 0;
        this.progressTotal =  this.questionLength > 0? this.questionLength : this.sectionLength > 0? this.sectionLength : 0;
        this.progress = !this.event?.enddate && this.progress === this.progressTotal? this.progressTotal * 0.99 : this.progress;  

    } 

    public static endPoint: string = 'sections' 
    public static endPointFilterList = (parentId?: number, tag?: string, seq?: number, eventId?: number) => {
        const owner = OwnerModel.getOwner();
        const user = UserModel.getUser();

        return ('?populate[owner][sort]=id' +
                '&populate[parent][sort]=id' +
                '&populate[product][sort]=id' +
                '&populate[section][sort]=id' +
                '&populate[quizquestion][sort]=id' + 
                '&populate[event][sort]=id' +
                '&populate[event][populate][parent][sort]=id' +
                '&populate[event][populate][event][sort]=id' +
                '&populate[event][populate][eventquiz][sort]=id' +
                '&populate[event][populate][eventquiz][populate]=quizanswer' +
                '&populate[event][populate][participant][sort]=id' +
                '&populate[event][populate][participant][popuplate]=user' +
                '&populate[event][filters][parent][id]=' + eventId +
                '&populate[event][filters][participant][user]=' + user +
                '&populate[eventquiz][sort]=id' +
                '&populate[image][sort]=id' +
                'sort=seq'+
                '&filters[owner]=' + owner +
                '&filters[parent]' + (parentId? '=' + parentId : '[id][$null]=true') +
                (tag? '&filters[tag]=' + tag : '') +
                (seq? '&filters[seq]=' + seq : '') +
                (!parentId && !tag && eventId? '&filters[event]=' + eventId : '') 
                );
    }
    public static url: string = '/section';
    public static caption: string = 'Section';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),   
        parent: null,
        parentCaption: '',
        title: '',
        content: '',
        seq: 0,
        option: null,
        viewstyle: 'onebyone',
        timelimit: 0,
        questiontolerance: 0,
        tag: '',
        image: null,
        imageId: 0,
        imageUrl: '',
        sectionLength: 0,
        questionLength: 0,       
        event: null,
        progress: 0,
        progressTotal: 0,
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
    ]

    public static columnPicklistCard = [
        { name: 'option', type: 'option' },
        { name: 'imageUrl', type: 'media', width: {xs: '170%', md: '100%'} },
        { name: 'title', type: 'caption', color: 'primary.main', size: 'large'},
        { name: 'content', size: 'medium', textAlign: 'justify', noWrap: true },
        { name: 'progress', type: 'progress', value: 0, total: 'progressTotal', icon: 'military_tech', iconColor: 'gold' },
        { name: 'children', type: 'children', children: undefined},
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
        
    public static optionType = [
        { name: 'page', caption: 'Page' },
        { name: 'cover', caption: 'Cover' },
        { name: 'header', caption: 'Header' },
        { name: 'body', caption: 'Body' },
        { name: 'footer', caption: 'Footer' },
        { name: 'gallery', caption: 'Gallery' },
    ]

    public static optionViewstyle = [
        { name: 'all', caption: 'Show All' },
        { name: 'onebyone', caption: 'Show One by One' },
        { name: 'all-canback', caption: 'Show All & Can Back' },
        { name: 'onebyone-canback', caption: 'Show One by One & Can back' },
    ]

}